import * as R from 'ramda';

const formatGraphData = dataObj =>
  R.compose(
    // Reverses list to get chronological order
    R.reverse,
    // Adds in new object to beginning of list containing label and volume
    R.prepend(
      {
        date: 'Rolling 12 Months',
        volume: R.path(['volumes', 'twelveMonthVolume', 'summedVolume'])(dataObj),
      },
      R.__
    ),
    // Takes in selected list of volumes for a global customer
    R.path(['volumes', 'lastFourYearsVolume'])
  )(dataObj);

export default formatGraphData;
